import { SubnavMenuItemId } from "domains/nav/types/subnavMenuItemId";

// TODO centralise with routing logic
export const getActiveItemId = (pathname: string) => {
  if (pathname === "/") return SubnavMenuItemId.HOME;
  else if (pathname.startsWith("/about")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/bookmarks")) return SubnavMenuItemId.MORE;
  else if (pathname === "/collection" || (pathname.startsWith("/collection") && pathname.endsWith("/edit")))
    return SubnavMenuItemId.CREATE;
  else if (pathname.startsWith("/collection")) return SubnavMenuItemId.DISCOVER;
  else if (pathname.startsWith("/cookie-notice")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/create")) return SubnavMenuItemId.CREATE;
  else if (pathname.startsWith("/discover")) return SubnavMenuItemId.DISCOVER;
  else if (pathname.startsWith("/faq")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/followed")) return SubnavMenuItemId.DISCOVER;
  else if (pathname.startsWith("/moderate")) return SubnavMenuItemId.MODERATE;
  else if (pathname.startsWith("/monitor")) return SubnavMenuItemId.MONITOR;
  else if (pathname.startsWith("/privacy-policy")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/resources")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/shared")) return SubnavMenuItemId.CREATE;
  else if (pathname.startsWith("/terms-and-conditions")) return SubnavMenuItemId.MORE;
  else if (pathname.startsWith("/topics")) return SubnavMenuItemId.DISCOVER;
  return undefined;
};
